import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthService from '@/service/auth/AuthService'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err === undefined || err === false) {
      // next('/other') next(false) 고려..
      console.log(err, 'location')
    } else {
      console.error(err, 'location')
    }
  })
}
Vue.use(VueRouter)

let routers = [
  require('./main'),
  require('./error'),
  require('./signup'),
  require('./signout'),
  require('./dashboard'),
  require('./cardsales'),
  require('./ordersales'),
  require('./factoring'),
  require('./documents'), // 서류 제출
  require('./agreements'), // 약관 및 이용동의
  require('./callback'),
  require('./terms'),
  require('./event/preReservation'),
  require('./my'),
  require('./notices'),
  require('./loan'),
  require('./app'),
  require('./signin'),
  require('./pirate'),
  require('./talks'),
  require('./todaystore'),
  require('./landing'),
  require('./kyc'),
  require('./marketing'),
  require('./woori-crowd'),
]

let mergeRouters = []
routers.forEach(route => {
  mergeRouters = mergeRouters.concat(route.default)
})

let router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: mergeRouters,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

let ignores = [ // routesWithoutSignin
  'main',
  'pirate',
  'signin',
  'signout',
  'signoutAuto',
  'error404',
  'maintenance',
  'terms/privacy',
  'terms/service',
  'app/loading',
  'todaystore',
  'todaystore/event',
  'todaystore/landing',
  'connect/todaystore',
  'landing',
  'landing/invitation/corona',
  'landing/overcome-corona',
  'landing/invitation/bnk',
  'landing/manual',
  'terms/detail',
  'marketing',
]

let routesHidesChannelTalk = [
  'documents/loan',
  'talks',
  'talks/:uuid',
  'terms/service',
  'maintenance',
  'documents/limittransaction',
]

function isIgnore(to) {
  for (let i = 0; i < ignores.length; i++) {
    // Variable Section
    const ignore = ignores[i]
    // Main Section
    if (ignore === to.name) {
      return true
    }
  }
  return false
}

function hideChannelTalk(to) {
  let isHide = false
  for (let i = 0; i < ignores.length; i++) {
    // Variable Section
    const route = routesHidesChannelTalk[i]
    // Main Section
    if (route === to.name) {
      // Hide Channel Talk
      setTimeout(function () {
        let eleCh = document.getElementById('ch-plugin')
        if (eleCh) {
          eleCh.style.display = 'none'
        }
      }, 500)
      isHide = true
    }
  }
  if (!isHide) {
    // Show Channel Talk
    setTimeout(function () {
      let eleCh = document.getElementById('ch-plugin')
      if (eleCh) {
        eleCh.style.display = 'block'
      }
    }, 500)
  }
}

// global interceptor
router.beforeEach(async (to, from, next) => {
  // 비 로그인 시 로그인 페이지로 redirect
  let isIgnorePath = isIgnore(to)
  hideChannelTalk(to)
  if (isIgnorePath === false && AuthService.isSignin() === false) {
    next({ path: `?redirectUri=${to.fullPath}` })
    return
  }

  if (AuthService.isTokenExpire()) {
    await AuthService.sync()
    next()
  } else {
    next()
  }
})

export default router
